import Script from 'next/script';
import {useCallback} from 'react';
import {getEnv} from '../../env/env';
import {IS_CLIENT_SIDE} from '../../shared/utils/constants';

export function AdfitScript() {
  const onLoad = useCallback(() => {
    window.adfit();
  }, []);

  return (
    <>
      {/* 이미 script가 로드되어 window에 박혀있으면 스크립트를 추가 로드하지 않습니다. */}
      {IS_CLIENT_SIDE && !window.adfit && (
        <Script src={getEnv().daSdkUrl} onLoad={onLoad} />
      )}
      {/* 뷰어 앤드 확장형 광고가 네이티브에서 배너로 변경 됨에 따라 아직 네이티브 광고를 제공하는 곳이 없어 주석처리 해 놓습니다.
        IS_CLIENT_SIDE && !(window as any).AdfitNativeAds && (
        <Script src={getEnv().daNaSdkUrl} onLoad={onLoadNative} />
      )
      */}
    </>
  );
}
